export default __webpack_public_path__ + "static/media/mathematics.97b363c9.png";